import { observer } from 'mobx-react-lite';
import { commandToolbarLabel } from '../strings.locstring.json';
import loc from 'owa-localize';
import { ComposeCommandingBar } from 'owa-mail-compose-view';
import { MailCommandingBar } from 'owa-mail-commandbar';
import { SecondaryReadingPaneTabCommandingBar } from 'owa-mail-reading-pane-view';
import { listViewStore } from 'owa-mail-list-store';
import { TabViewState, TabType } from 'owa-tab-store';
import getFullComposeShowingInTabContentArea from 'owa-mail-compose-actions/lib/selectors/getFullComposeShowingInTabContentArea';
import { globalStyles } from 'owa-global-styles';
import * as React from 'react';
import {
    isReadingPanePositionOff,
    isReadingPanePositionRight,
    getListViewDimensions,
    shouldShowFolderPaneAsOverlay,
    shouldShowFolderPane,
} from 'owa-mail-layout';
import { shouldShowCommandBarHamburgerButton } from 'owa-mail-filterable-menu-behavior';
import LeftPaneHamburgerButton from 'owa-mail-commandbar/lib/components/LeftPaneHamburgerButton';

const styles = require('./MailModule.scss');
const classNames = require('classnames/bind').bind(styles);

export interface MailCommandBarViewProps {
    activeTab: TabViewState;
    isDumpsterOrDumpsterSearchTable: boolean;
    leftPadding?: number;
}

export default observer(function MailCommandBarView(props: MailCommandBarViewProps) {
    const renderCommandBar = () => {
        const { activeTab, isDumpsterOrDumpsterSearchTable } = props;
        const activeFullComposeViewState = getFullComposeShowingInTabContentArea();
        const isShowingSecondaryReadingPane =
            activeTab && activeTab.type == TabType.SecondaryReadingPane;
        const shouldShowComposeHamburgerButton = shouldShowCommandBarHamburgerButton();
        let commandBarPadding;
        let renderCommandBarCustomItem = shouldShowComposeHamburgerButton
            ? () => (
                  <LeftPaneHamburgerButton
                      isPaneExpanded={shouldShowFolderPane() && shouldShowFolderPaneAsOverlay()}
                  />
              )
            : null;

        if (activeFullComposeViewState && isReadingPanePositionRight()) {
            // The hamburger button is rendered in the compose command bar when the metaOs flight is on
            // Since the button is 48px, we need less padding than the case where it's just the compose actions
            commandBarPadding = shouldShowComposeHamburgerButton
                ? getListViewDimensions().listViewWidth - 48
                : getListViewDimensions().listViewWidth;
        }

        if (
            !isDumpsterOrDumpsterSearchTable &&
            /* Should never show compose command bar if in dumpster */ activeFullComposeViewState
        ) {
            return (
                <ComposeCommandingBar
                    composeViewState={activeFullComposeViewState}
                    leftPadding={commandBarPadding}
                    renderCustomItem={renderCommandBarCustomItem}
                />
            );
        }
        if (isShowingSecondaryReadingPane) {
            return (
                <SecondaryReadingPaneTabCommandingBar
                    tab={activeTab}
                    readingPaneOff={isReadingPanePositionOff()}
                />
            );
        }
        return <MailCommandingBar tableViewId={listViewStore.selectedTableViewId} />;
    };
    return (
        <div
            tabIndex={-1}
            className={classNames(styles.commandBar, globalStyles.addFocusOutline)}
            role={'region'}
            aria-label={loc(commandToolbarLabel)}>
            {renderCommandBar()}
        </div>
    );
});
